import { TransparentButton, ButtonType, LargeButton } from '@checkmarx/cx-ui';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import PortalTextBox from '../../portal/portalTextBox';
import AuthenticationProvidersDropownContainer from '../authenticationProvidersDropown';
import ExternalSsoLogins from '../externalSsoLogins';
import Eula from '../eula';
import classNames from 'classnames';
import styles from '../externalSsoLogins/style.scss';

@inject('translationsStore', 'authStore', 'changePasswordStore',
    'authenticationProvidersStore', 'configurationsStore', 'twoFAStore', 'loginSettingsStore') @observer
export default class LoginFormContainer extends Component {

    loginStore = this.props.loginSettingsStore;
    authProvidersStore = this.props.authenticationProvidersStore;

    state = {
        displayCredentialsAsButton: this.loginStore.credentialsButton
    };

    componentWillUnmount() {
        this.props.authStore.resetPasswordForm();
    }

    selectProviderChange = (menuItem) => {

        this.props.authStore.setProviderId(menuItem.props.value);
    }

    handleUserNameChange = e => {
        this.props.authStore.setUserName(e.target.value);
    }
    handleUserNameOnBlur = e => {
        this.props.authStore.validateUserName();
    }

    handlePasswordChange = e => this.props.authStore.setPassword(e.target.value);
    handlePasswordOnBlur = e => this.props.authStore.validatePassword();

    displayLoginWithCredentials = (e) => {
        this.setState({ displayCredentialsAsButton: false });
    }

    hideLoginWithCredentials = (e) => {
        this.setState({ displayCredentialsAsButton: true });
    }

    handleSubmitForm = (e) => {

        e.preventDefault();

        const isValid = this.props.authStore.validateForm();

        if (isValid === false) {
            return;
        }

        this.props.authStore.setOrigin();
        this.props.authStore.isLoginError = false;
        this.props.authStore.loginErrorMessage = '';
        this.props.authStore.login().then((response) => {
            if (response.requireChangePassword === true) {
                this.props.changePasswordStore.setUsername(this.props.authStore.values.userName);
                if (this.props.configurationsStore.isMultitenancyMode) {
                    this.props.changePasswordStore.setTenant(this.props.authStore.values.tenant)
                }
                if (response.isPasswordExpired) {
                    this.props.changePasswordStore.setIsPasswordExpired(true);
                    this.props.authStore.setLoginStep(this.props.authStore.loginSteps.passwordExpired);
                }
                else {
                    this.props.authStore.setRequireChangePasswordForResetFlow(true);
                }
                return;
            }
            this.props.authStore.setTenant(response.tenant);
            window.localStorage.setItem('authStoreTenant', this.props.authStore.values.tenant);
            if (response.requireTwoFactorAuth === true) {
                this.props.authStore.setRequireTwoFactorAuth(true);
                this.props.authStore.values.isPasswordValidated = true;
                this.props.authStore.setUserName(response.userName);
                this.props.twoFAStore.setUsername(response.userName);
                if (response.requireAuthSetup === false) {
                    this.props.authStore.setLoginStep(this.props.authStore.loginSteps.twoFAForm);
                }
                else {
                    this.props.authStore.setRequireTwoFASetupToBeDone(true);
                }

                return;
            }
            window.location.href = this.props.returnUrl;
        });
    };

    sortLoginMethod() {
        return this.loginStore.defaultLoginMethod === 'CREDENTIALS';
    }
	
    renderSeparator(method){
        return  <div className={classNames(styles.ssoLoginSeperator)}>
                    {this.props.translationsStore.translate(method)}
                </div>
    };
	
    render() {
        const { values, requireChangePasswordForResetFlow, inProgress, userNameValidationMessage,
            passwordValidationMessage, selectedAuthProviderId, loginErrorMessage, requireTwoFactorAuth, requireTwoFASetupToBeDone } = this.props.authStore;

        const { credentialsButton, defaultLoginMethod } = this.loginStore;

        if (requireChangePasswordForResetFlow) {
            return <Redirect to='/changepassword' />;
        }

        if (requireTwoFASetupToBeDone) {
            return <Redirect to='/setupauth' />;
        }

        //keeps the last authentication provider selected in the login form during the session
        var defaultSelectedAuthProviderId = selectedAuthProviderId;

        if (window.localStorage.getItem('authStoreProviderId') == null) {

            //get the default login method for credentials
            this.authProvidersStore.authenticationProviders.map(function (provider) {
                if (provider.defaultMethod === true) {
                    defaultSelectedAuthProviderId = provider.id;
                    window.localStorage.setItem('defaultSelectedAuthProviderId', provider.id);
                }
            });

            //set the default login method value
            this.props.authStore.setProviderId(defaultSelectedAuthProviderId);
        }

        const usernameField = (<div>
            <div>
                <PortalTextBox
                    id='txtUserName'
                    dataCy='username'
                    hintText={this.props.translationsStore.translate('USER_NAME')}
                    floatingLabelText={this.props.translationsStore.translate('USER_NAME')}
                    disabled={inProgress}
                    autoComplete='on'
                    onChange={this.handleUserNameChange}
                    onBlur={this.handleUserNameOnBlur}
                    errorText={userNameValidationMessage}
                    width='325px'
                    value={values.userName}
                    ref='username'
                />
            </div>
        </div>);

        const passwordField = (<div>
            <div>
                <PortalTextBox
                    id='txtPassword'
                    dataCy='password'
                    hintText={this.props.translationsStore.translate('PASSWORD')}
                    floatingLabelText={this.props.translationsStore.translate('PASSWORD')}
                    disabled={inProgress}
                    autoComplete='on'
                    includeContentVisibilityToggle
                    onChange={this.handlePasswordChange}
                    onBlur={this.handlePasswordOnBlur}
                    errorText={passwordValidationMessage}
                    type='password'
                    width='325px'
                    value={values.password}
                    ref='password'
                />
            </div>
        </div>);

        var credentialsForm = (<form onSubmit={this.handleSubmitForm} disabled={!this.displayCredentialsAsButton}>
            {usernameField}
            {passwordField}
            <Eula style={{ marginTop: '25px' }} toggleEula={() => this.props.authStore.toggleAcceptedEula()} />
            <div
                className='authentication-providers-dropown-wrapper'
                style={{ marginTop: passwordValidationMessage ? 8 : 2 }}
            >
                <span className='portal-general-control-label'>
                    {this.props.translationsStore.translate('SIGNIN_USER_AS')}:
                </span>
                <div className='auth-ddl-wrapper'>
                    <AuthenticationProvidersDropownContainer
                        authenticationProviders={this.authProvidersStore.authenticationProviders}
                        selectProviderChange={this.selectProviderChange}
                        selectedProviderId={defaultSelectedAuthProviderId}
                    />
                </div>
            </div>
            <div>
                <LargeButton
                    type='submit'
                    id='btnLoginSubmit'
                    dataCy='login-button'
                    inProgress={inProgress}
                    text={this.props.translationsStore.translate('LOGIN')}
                    style={{ marginTop: '15px', width: '325px' }}
                    disabled={this.props.configurationsStore.isRequiredEulaHosted && !this.props.authStore.values.isAcceptedEula}
                />
            </div>
            <div hidden={!this.loginStore.credentialsButton}>
                <LargeButton
                    type='submit'
                    id='btnBackLoginSubmit'
                    dataCy='back-login-button'
                    inProgress={inProgress}
                    text={this.props.translationsStore.translate('BACK')}
                    style={{ marginTop: '15px', width: '325px' }}
                    onClick={this.hideLoginWithCredentials}
                />
            </div>
        </form>);

        var showCredentialsButton = (<TransparentButton disabled={!this.state.displayCredentialsAsButton}
            style={{
                color: '#4a90e2',
                borderColor: '#4a90e2',
                height: '40px',
                width: '325px',
                textTransform: 'initial',
                fontSize: '15px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }}
            type='button'
            onClick={this.displayLoginWithCredentials}
            text={this.props.translationsStore.translate('LOGIN_WITH_CREDENTIALS')}
        />
        );

        var credentialsPresentation = this.state.displayCredentialsAsButton ? showCredentialsButton : credentialsForm;

        var externalSsoLogins = (<ExternalSsoLogins
            authProvidersStore={this.authProvidersStore}
            loginSettingsStore={this.loginStore}
            translationsStore={this.props.translationsStore}
            returnUrl={this.props.returnUrl}
        />);

        let loginForm;

        const ssoAauthenticationProviders = this.authProvidersStore.authenticationProviders.filter(authProvider => authProvider.active && authProvider.isExternal);

        if (ssoAauthenticationProviders.length > 0) {

            loginForm = this.loginStore.defaultLoginMethod === 'CREDENTIALS' ?
                (<div> {this.renderSeparator('SIGN_IN_USING_CREDENTIALS')} {credentialsPresentation} {externalSsoLogins} </div>) :
                (<div> {externalSsoLogins} {this.renderSeparator('SIGN_IN_USING_CREDENTIALS')} {credentialsPresentation} </div>);
        }
        else {
            loginForm = (<div>{credentialsPresentation}</div>);
        }

        return (
            <div className='login-form'>
                <div className='general-form-wrapper login'>
                    <ValidationTopErrorMessage errorMessage={loginErrorMessage} />
                    {loginForm}
                </div>
            </div>
        );
    }
}